// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kanban_content {\n  padding: 20px;\n}\n.headerTitle {\n  font-size: 25px;\n  text-align: center;\n  font-weight: bold;\n}\n.cloumH1 {\n  font-weight: bold;\n  color: black\n}\n", ""]);
// Exports
module.exports = exports;
